export default __webpack_public_path__ + "static/media/logo(new).0bef9a33.png";